module.exports = __webpack_public_path__ + "static/media/icon-back10s.cad711a4.svg";